// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e29d18c3","239":"1351db95","389":"187bf49d","732":"ed53e1ac","857":"0476484e","977":"9de0f9f8"}[chunkId] + ".chunk.js";
};